import { render } from "./UserAccountLogs.vue?vue&type=template&id=243d2a6a"
import script from "./UserAccountLogs.vue?vue&type=script&lang=js"
export * from "./UserAccountLogs.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/logs/UserAccountLogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "243d2a6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('243d2a6a', __exports__)) {
    console.log('reload')
    api.reload('243d2a6a', __exports__)
  }
  
  module.hot.accept("./UserAccountLogs.vue?vue&type=template&id=243d2a6a", () => {
    console.log('re-render')
    api.rerender('243d2a6a', render)
  })

}


export default __exports__